export const listSVGIcon05 = {};
